import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { UpdateInvitacionesAsesoriaCommandProps } from "api/Commands/UpdateInvitacionesAsesoriaCommand"
import { AsesoriaGetEmpresaActivaUsuarioDtoProps } from "api/DTOs/AsesoriaGetEmpresaActivaUsuarioDto"
import { InvitacionesAsesoriaAdapted } from "common/pages/Dashboard/asesoriasInvitaciones.adapter"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Message } from "primereact/message"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { convertImgBase64 } from "utils/convertBase64"
import InvitationsList from "./InvitationList"

export interface ModalCierreCargandoProps {
  isOpen: boolean
  onConfirmAsesoria: (
    statusAsesorias: UpdateInvitacionesAsesoriaCommandProps
  ) => void
  onCloseModal: () => void
  data?: InvitacionesAsesoriaAdapted[]
  asesoriaActiva?: AsesoriaGetEmpresaActivaUsuarioDtoProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setManageModalAsesoriaActiva?: $TSMigrationFixMe
}

export const ModalInvitacionesAsesorias = ({
  isOpen = false,
  onConfirmAsesoria,
  onCloseModal,
  data,
  asesoriaActiva,
  setManageModalAsesoriaActiva,
}: ModalCierreCargandoProps) => {
  const { t } = useTranslation()
  const [statusAsesorias, setStatusAsesorias] =
    useState<UpdateInvitacionesAsesoriaCommandProps>({
      invitaciones: [],
    })
  const [showWarningMessage, setShowWarningMessage] = useState(false)

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-192 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-mb-6'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
            {t("crear.asesoria.modal.title")}
          </p>
          <ButtonPrimeReact
            className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
            onClick={() => {
              onCloseModal()
              setShowWarningMessage(false)
            }}
          >
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5'
            />
          </ButtonPrimeReact>
        </div>
      }
      footer={
        <div
          key='Actions'
          className='tw-flex tw-flex-row tw-justify-end tw-gap-3 tw-mt-3'
        >
          <ButtonPrimeReact
            label={`${t("crear.asesoria.modal.exitButton")}`}
            className='tw-h-12 !tw-bg-inherit !tw-border-none !tw-text-text tw-items-center'
            onClick={() => {
              onCloseModal()
              setShowWarningMessage(false)
            }}
          />
          <ButtonPrimeReact
            id='confirmModal'
            label={`${t("crear.asesoria.modal.continueButton")}`}
            className='tw-h-12 !tw-bg-primary !tw-border-none tw-text-simple-10 tw-items-center'
            onClick={() => {
              onConfirmAsesoria(statusAsesorias)
              asesoriaActiva &&
                setManageModalAsesoriaActiva({
                  showModalAsesoria: false,
                  deleteAsesoria: false,
                })
              onCloseModal()
              setShowWarningMessage(false)
            }}
          />
        </div>
      }
    >
      <div>
        <p className='!tw-mb-4'>{t("crear.asesoria.modal.firstText")}</p>
        <Message
          className='tw-w-full tw-pl-4 tw-mb-4 !tw-border !tw-border-info'
          severity='info'
          text={`${t("crear.asesoria.modal.infoMessage")}`}
        />
        <p className='!tw-mb-4'>{t("crear.asesoria.modal.secondText")}</p>
        {asesoriaActiva?.invitacionId && showWarningMessage && (
          <Message
            className='tw-w-full tw-pl-4 tw-mb-4 !tw-border !tw-border-warning !tw-bg-warning-10 !tw-text-warning'
            severity='warn'
            text={`${t("crear.asesoria.modal.warningMessage")}`}
          />
        )}
        {asesoriaActiva?.invitacionId && (
          <>
            <p className='tw-font-medium tw-text-base !tw-mb-2'>
              {t("crear.asesoria.modal.currentAsesoría")}:
            </p>
            <div className='tw-bg-simple-10 tw-w-full tw-px-4 tw-py-3 tw-rounded tw-shadow tw-mb-4 tw-grid tw-grid-cols-8'>
              <div className='tw-flex tw-items-center tw-justify-center tw-col-span-1 tw-mr-3'>
                {asesoriaActiva?.logo?.base64 ? (
                  <img
                    className='tw-h-10 tw-object-contain'
                    alt='logoAsesoriaActivaInvitacion'
                    src={convertImgBase64({
                      base64: asesoriaActiva.logo?.base64,
                      mediaType: asesoriaActiva.logo?.mediaType,
                    })}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={["fal", "handshake"]}
                    className='tw-self-center tw-w-5 tw-h-5'
                  />
                )}
              </div>
              <div className='tw-flex-col tw-text-left tw-col-span-7'>
                <p className='tw-mb-1 tw-h-5 tw-font-medium tw-max-w-96 tw-truncate'>
                  {asesoriaActiva?.razonSocial}
                </p>
                <p className='tw-mb-0 tw-text-text tw-text-xs'>
                  {asesoriaActiva?.provinciaRegistroMercantil}
                </p>
              </div>
            </div>
          </>
        )}
        <InvitationsList
          data={data ?? []}
          setStatusAsesorias={setStatusAsesorias}
          setShowWarningMessage={setShowWarningMessage}
        />
      </div>
    </PrimeReactModal>
  )
}
